import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Typography, Grid, Divider, IconButton } from '@material-ui/core';
import PageTitle from '../../components/ui/PageTitleUI';
import ButtonUI from '../../components/ui/ButtonUI';
import LoadingUI from '../../components/ui/LoadingUI';
import { useStyles } from './Style'
import WindowApi from '../../services/WindowApi';
import { useTranslation } from 'react-i18next';
import {
    Search as SearchIcon,
    BackspaceOutlined as BackspaceOutlinedIcon,
    Delete as DeleteIcon,
    Add as AddIcon,
} from '@material-ui/icons';
import MUIDataTable from "mui-datatables";
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import useKeypress from '../../utils/useKeypress'
import { useAuth } from '../../hooks/auth';
import utilsDate from '../../utils/Date';
import OptionValueApi from '../../services/OptionValueApi';
import AlertDialog from '../../components/ui/AlertDialog';
import { useSnackbar } from 'notistack';
import BoxSlide from '../../components/ui/BoxSlideUI';
import WindowForm from '../Window/WindowForm';
import { useForm } from 'react-hook-form';
import TextField from '../../components/Form/TextField';
import Select from '../../components/Form/Select';
import SelectSupplier from '../../components/Form/SelectSupplier';
import getDefaultGridOptions from '../../utils/componentUtils';
import Success from '../../components/Form/Success';
import { useLocation } from 'react-router-dom';
import permissions from '../../utils/Permissions';
import { PERIMETER_DAFAULT } from '../../utils/constants';

interface IFormInput {
    perimeter: any;
    supplier: any;
    hour: string;
}

const opcoes = [
    { url: '/window', descricao: 'Incluir', state: { openPanelOnLoad: true } },
    { url: '/window', descricao: 'Pesquisar', state: {} }
]

interface Params {
    openPanelOnLoad: boolean;
}

const Window: React.FC = () => {
    const classes = useStyles();
    const { isPortoReal } = useAuth();
    const location = useLocation<Params>();
    const [windows, setWindows] = useState<any>();
    const [count, setCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(0);
    const [sort, setSort] = useState<string>('id:desc');
    const [loading, setLoading] = useState(true);
    const [openedPainel, setOpenedPainel] = React.useState(false);
    const [windowId, setWindowId] = useState<number>(0);
    const { t } = useTranslation("Window");
    const { t: _t } = useTranslation("General");
    const { user, hasPermission } = useAuth();
    const history = useHistory();
    const [perimeters, setPerimeters] = useState<any>([]);
    const { enqueueSnackbar } = useSnackbar();
    const { handleSubmit, reset, control, getValues, setValue } = useForm<IFormInput>(
        {
            defaultValues: { perimeter: { code: '', label: '' }, supplier: { code: '' }, hour: '' }
        });

    const [success, setSuccess] = useState(false);
    const rowsPerPageOptDefault = [10, 15, 100]
    const [rowsPerPageOpt, setRowsPerPageOpt] = useState<number[]>(rowsPerPageOptDefault)


    const columns = [
        {
            name: 'id',
            options: { display: false, download: false }
        },
        {
            name: 'flagMonday',
            options: { display: false, download: false }
        },
        {
            name: 'flagTuesday',
            options: { display: false, download: false }
        },
        {
            name: 'flagWednesday',
            options: { display: false, download: false }
        },
        {
            name: 'flagThursday',
            options: { display: false, download: false }
        },
        {
            name: 'flagFriday',
            options: { display: false, download: false }
        },
        {
            name: 'flagSaturday',
            options: { display: false, download: false }
        },
        {
            name: 'flagSunday',
            options: { display: false, download: false }
        },
        {
            name: 'supplierName',
            options: { display: false, download: false }
        },
        {
            name: 'perimeter',
            label: String(t('perimeter')),
            options: {
                setCellProps: () => ({
                    align: "left"
                })
            }
        },
        {
            name: 'supplierId',
            label: String(_t('supplier')),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return value + " - " + tableMeta.rowData[8];
                }
            }
        },
        {
            name: 'flagDays',
            label: String(t('weekDays')),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    var days = [];
                    if (tableMeta.rowData[7]) days.push(t("weekShortNameSUN"));
                    if (tableMeta.rowData[1]) days.push(t("weekShortNameMON"));
                    if (tableMeta.rowData[2]) days.push(t("weekShortNameTUE"));
                    if (tableMeta.rowData[3]) days.push(t("weekShortNameWED"));
                    if (tableMeta.rowData[4]) days.push(t("weekShortNameTHU"));
                    if (tableMeta.rowData[5]) days.push(t("weekShortNameFRI"));
                    if (tableMeta.rowData[6]) days.push(t("weekShortNameSAT"));

                    return days.join(", ");
                }
            }
        },
        {
            name: 'hourConcierge',
            label: String(t('hour')),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.TimeShort(value);
                }
            }
        },
        {
            name: 'windowSheds',
            label: String(t('sheds')),
            options: {
                display: false,
                sort: false,
                download: true,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return renderWindowShedsString(value);
                }
            }
        },
        {
            name: 'windowSheds',
            label: String(t('sheds')),
            options: {
                download: false,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return renderWindowSheds(value);
                }
            }
        },
        {
            name: 'updatedBy',
            label: String(_t('updatedBy')),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: 'updatedAt',
            label: String(_t('updatedAt')),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateTime(value);
                }
            }
        },
        {
            name: "id",
            label: " ",
            options: {
                setCellProps: () => ({
                    align: "right"
                }),
                download: false,
                disableClick: true,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
                    renderButtons(value)
                )
            }
        },
    ]

    const renderButtons = (id: any) => {
        return (
            <AlertDialog
                dialogTitle={_t("dialogDeleteTitle")}
                dialogContentText={_t("dialogDeleteContentText")}
                cancelTextButton={_t("cancel")}
                confirmTextButton={_t("confirm")}
                confirmDialogFunction={() => { handleDeleteItem(id); }}
                Button={
                    <IconButton size='small' edge="end" disabled={!hasPermission(permissions.DELIVERY_WINDOW.Delete)}>
                        <DeleteIcon />
                    </IconButton>
                }
            />
        );
    }

    function handleDeleteItem(id: number) {
        WindowApi.delete(id)
            .then(result => {
                enqueueSnackbar(_t("returnSubmitDeleteFormSuccess"), { variant: 'success' });
            }).finally(() => {
                setLoading(true);
            });
    };

    useKeypress('Escape', () => {
        setOpenedPainel(false);
    });

    useEffect(() => {
        if (!hasPermission(permissions.DELIVERY_WINDOW.Search))
            history.replace('NoPermission');
        if (isPortoReal()) {
            setPerimeters(PERIMETER_DAFAULT);
        }
        else {
            OptionValueApi.search('AePerimetroJanela').then(response => {
                if (response) {
                    setPerimeters(response.map(
                        (item: any) => ({
                            code: item.code, label: item.description
                        })))
                }
            });
        }

        setWindows([]);
        setLoading(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, history]);

    //Realizar pesquisa: Ao mudar a propriedade Loading, ou ao alterar propriedades/paginacao da grid
    useEffect(() => {
        if (loading === false)
            return

        const data = getValues()

        let finalData = {
            perimeter: data.perimeter?.code,
            suppliersId: data.supplier?.code,
            hour: data.hour,
            companyId: user.company.companyID,
            PageSize: rowsPerPage !== 0 ? rowsPerPage : 10,
            PageIndex: page, Sort: sort
        }

        //Buscar por fornecedores do Usuario Fornecedor
        if (user.isSupplier && data.supplier?.code === '')
            finalData.suppliersId = user.suppliers.map((element: { code: any; }) => Number(element.code)).join(',');

        setLoading(true);
        WindowApi.searchWindow(finalData)
            .then(result => {
                if (result && result.items) {
                    setWindows(result)
                    setPage(result.pageIndex)
                    setRowsPerPage(result.pageSize)
                    setCount(result.totalCount)
                }
                else {
                    setWindows([]);
                }
            }).catch(() => {
                setWindows([]);
            }).finally(() => {
                setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, page, rowsPerPage, sort, user]);

    function createNewWindow() {
        setWindowId(0);
        setOpenedPainel(true);
    }

    useEffect(() => {

        if (windows?.totalCount > 100) {
            let rowsPerPageOptTmp = rowsPerPageOptDefault
            rowsPerPageOptTmp.push(windows.totalCount)
            setRowsPerPageOpt(rowsPerPageOptTmp)
        }
        else
            setRowsPerPageOpt(rowsPerPageOptDefault)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [windows])

    const onSubmit = (data: any) => {
        setPage(0)
        setRowsPerPage(0)
        setLoading(true)
    }

    //Lidar com alteracoes da grid:
    function handleChangePage(newPage: number) {
        setPage(newPage);
        setLoading(true);
    };

    function handleChangeRowsPerPage(rowsPerPage: number) {
        setRowsPerPage(rowsPerPage);
        setPage(0);
        setLoading(true);
    };

    function handleSortClick(column: string, orderDirection: string) {
        setSort(`${column}:${orderDirection}`);
        setLoading(true);
    };
    //Fim alteracoes da grid


    //Grid: Renderizar os galpoes com quebra de linha:
    const renderWindowSheds = (row: any) => {
        return row.map((x: any) => { return (<div key={x.shedId}>{x.shedCode} - {x.shedType === "D" ? t('unload') : t('load')} - {x.movementTypeDescription} - {x.startTime} - {x.tolerance}</div>) });
    }

    const renderWindowShedsString = (row: any) => {
        const value = row.map((x: any) => { return (`${x.shedCode} - ${x.shedType === "D" ? t('unload') : t('load')} - ${x.movementTypeDescription} - ${x.startTime} - ${x.tolerance}`) })
        const valueString = value.join('\n')
        return valueString
    }

    const handleOpenPanelChange = (id: any) => {
        setWindowId(id);
        setOpenedPainel(true);
    };

    const options = {
        ...getDefaultGridOptions(_t),
        sortOrder: { name: sort.split(':')[0], direction: sort.split(':')[1] } as any
    };

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: windows?.items ? 'pointer' : ''
                }
            }
        }
    })

    useEffect(() => {
        if (location.state?.openPanelOnLoad) {
            createNewWindow()
        }
    }, [location.state?.openPanelOnLoad])

    if (success)
        return (
            <Container maxWidth={false} component="main">
                <div className={classes.rootContent}>
                    <div className={classes.paper}>
                        <Success opcoes={opcoes} />
                    </div>
                </div>
            </Container>
        )
    else
        return (
            <Container maxWidth={false} component="main">
                <PageTitle title={t("title")} />

                <div className={classes.rootContent}>
                    <div className={classes.paper}>

                        {/* Form de inclusao */}
                        <BoxSlide width='60%' isOpen={openedPainel} onClose={() => { setOpenedPainel(false); }}>
                            <WindowForm modelId={windowId} handleSetSuccess={setSuccess} traduction={t("Window")} perimeterList={perimeters} clickHandlerClose={() => { setWindowId(0); setOpenedPainel(false); }} />
                        </BoxSlide>

                        {/* Form de pesquisa */}
                        <form onSubmit={handleSubmit(onSubmit)} >
                            <Grid container spacing={1}>
                                <Grid item xs={6} style={{ padding: "0px", display: 'flex', alignItems: 'center' }}>
                                    <Typography className={classes.root}>
                                        {t("titleSearch")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} style={{ padding: "0px", textAlign: 'right' }}>
                                    <ButtonUI disabled={!hasPermission(permissions.DELIVERY_WINDOW.Add)} onClick={() => createNewWindow()} startIcon={<AddIcon />}>{_t("add")}</ButtonUI>
                                    <ButtonUI onClick={() => reset()} startIcon={<BackspaceOutlinedIcon />}>{_t("clean")}</ButtonUI>
                                    <ButtonUI type="submit" color="primary" startIcon={<SearchIcon />}>{_t("search")}</ButtonUI>
                                </Grid>
                            </Grid>
                            <Divider style={{ marginTop: '10px' }} />
                            <Grid container spacing={1}>
                                <Grid item xs={2} >
                                    <Select
                                        label={t('perimeter')}
                                        name={'perimeter'}
                                        control={control}
                                        options={perimeters}
                                        style={{ width: '100%' }} />
                                </Grid>
                                <Grid item xs={3}>
                                    <SelectSupplier
                                        name={"supplier"}
                                        control={control}
                                        getValues={getValues}
                                        setValue={setValue}
                                        style={{ width: '100%' }} />
                                </Grid>
                                <Grid item xs={1}>
                                    <TextField
                                        label={t("hour")}
                                        name="hour"
                                        control={control}
                                        mask="99:99"
                                        fullWidth />
                                </Grid>
                            </Grid>
                        </form>

                        {/* Grid Pesquisa */}
                        {
                            loading ? <LoadingUI /> :
                                <MuiThemeProvider theme={myTheme}>
                                    <MUIDataTable
                                        title=""
                                        data={windows?.items}
                                        columns={columns}
                                        options={{
                                            ...options,
                                            serverSide: true,
                                            pagination: true,
                                            page: page,
                                            count: count,
                                            rowsPerPage: rowsPerPage,
                                            sort: false,
                                            selectToolbarPlacement: "none",
                                            filter: false,
                                            search: false,
                                            download: true,
                                            print: false,
                                            viewColumns: false,
                                            selectableRows: 'none',
                                            downloadOptions: {
                                                filename: t("title"),
                                                separator: ';',
                                                filterOptions: {
                                                    useDisplayedRowsOnly: true
                                                }
                                            },
                                            onCellClick: (_colData, { colIndex, dataIndex }) => {
                                                if (hasPermission(permissions.DELIVERY_WINDOW.Edit))
                                                    if (windows?.items && colIndex < 16)
                                                        handleOpenPanelChange(windows.items[dataIndex].id);
                                            },
                                            onChangePage: (pageIndex) => { handleChangePage(pageIndex); },
                                            onChangeRowsPerPage: (rowsPerPage) => { handleChangeRowsPerPage(rowsPerPage); },
                                            onColumnSortChange: (column, dir) => { handleSortClick(column, dir); },
                                            rowsPerPageOptions: rowsPerPageOpt
                                        }}
                                    />
                                </MuiThemeProvider>
                        }
                    </div>
                </div>
            </Container>
        )
}
export default Window;
